import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useRegistrationForm } from "../provider/registrationFormProviderContext";
import { RegistrationDefaultEndPage } from "./RegistrationDefaultEndPage";

export const RegistrationDeclinedPage = () => {
	const { t } = useTranslation();
	const { registrationForm } = useRegistrationForm();
	const navigate = useNavigate();

	if (!registrationForm.isDeclinable) {
		navigate("../landing-page");
	}

	return (
		<RegistrationDefaultEndPage
			headline={t("Declination confirmed")}
			text={t("Thank you for letting us know that you are unable to attend.")}
			blockId={registrationForm.declinedBlockId}
		/>
	);
};
